import get from 'lodash/get';
import { useQuery } from '@tanstack/react-query';
import { queryRequest } from '../../apiClient';
import { QUERY_KEYS } from '../../constants/graphqlQueries';
import { GET_EMPLOYEE_DETAILS } from '../../queries/employee.queries';
import LONG_QUERY_CACHING_CONFIG from '../../../constants/longQueryCachingConfig';

// eslint-disable-next-line no-unused-vars
export const fetchEmployeeDetails = async (email) => {
  const response = await queryRequest(GET_EMPLOYEE_DETAILS, { email: '' });
  return get(response, 'data.data', {});
};

const selectEmployeeDetails = (data) => {
  const employeeData = get(data, 'spEmployee', {});
  const authorizationData = get(data, 'spEmployeeAuthorization', {});
  const officeIds = get(authorizationData, 'data.officeIds', []);
  const roleNames = get(authorizationData, 'data.roleNames', []);

  return {
    ...employeeData,
    officeIds,
    roleNames,
  };
};

export const useEmployeeDetails = (email) => {
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: [QUERY_KEYS.EMPLOYEE_DETAILS, email],
    queryFn: () => fetchEmployeeDetails(email),
    select: selectEmployeeDetails,
    ...LONG_QUERY_CACHING_CONFIG,
  });

  return {
    data: data || {},
    isLoading,
    isError,
    refetch,
  };
};
